/*
Version 0.120

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2020.

!Changelog

2020
	28-22-2020
	- [CHANGE] Some things
2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_360 = {};

(function(){

	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
		/*
		Load the tour
		Load the tour
		Load the tour
		Load the tour
		*/
		var _coordinates_array;
		var _scene_step;
		
		var search1 				= new URLSearchParams(window.location.search);

		/*
		Catch URL
		*/
		var _zoom_on_mousewheel 	= search1.get("mousewheel");
		var _autoplay 				= search1.get("autoplay");
		var _button_color 			= search1.get("button_color");
		var _button_position 		= search1.get("button_position");
			
		/*
		Load KRPano wrapper
		*/
		if(_device == 'desktop') {
			
			embedpano({
				swf 				:globalUrl + "/vtour/tour.swf", 
				xml 				:globalUrl + "/vtour/tour.xml?v=" + Math.random(),
				target 				:"tour",
				html5 				:"always",
				mobilescale 		:1.0,
				passQueryParameters :true,
				focus				:false,
				mwheel 				:true,
				bgcolor 			:"#ffffff"
			});
		
		} else {
			
			// embedpano({
			// 	swf 				:globalUrl + "/vtour/tour.swf", 
			// 	xml 				:globalUrl + "/vtour/tour-mobile.xml?v=" + Math.random(),
			// 	target 				:"tour",
			// 	html5 				:"always",
			// 	mobilescale 		:1.0,
			// 	passQueryParameters :true,
			// 	focus				:false,
			// 	mwheel 				:true,
			// 	bgcolor 			:"#ffffff"
			// });
			
		}
		
		/*
		Bind listeners
		*/
		$(document).on('click','html body',function() {
		  krpano.call('set(autorotate.enabled,false)');
		});

		$(document).on('click','.js-view-ceiling',function() {
			krpano.call('moveto(-45.20860898213328,-89.072130433938780,100);');
		});
		
		/*
		Define KRPano
		*/
		krpano = document.getElementById('krpanoSWFObject');
			
		setTimeout(function() {
			
			/*
			Load URL
			*/
			specific_360.updateUrl('');
			
			/**
			Catch coordinates
			**/
			//specific_360.trackCoordinates();
			
			/**
			Check Gyro / VR on Desktop / Mobile
			**/
			switch(_device) {
			
				case 'desktop':
					//$('.js-button-fullscreen').show();
					//$('.js-button-360').hide();
					//$('.js-button-vr').hide();	
				break;
				
				case 'tablet':
					//$('.js-button-fullscreen').hide();
					//$('.js-button-360').show();
					//$('.js-button-vr').hide();	
				break;
				
				case 'smartphone':
					//$('.js-button-fullscreen').show();
					//$('.js-button-360').show();
					//$('.js-button-vr').show();	
				break;
				
			}
			
			/**
			Set Autoplay
			**/
			//if(_autoplay == 'true') {
			//setTimeout(function() {
			//	krpano.call('set(autorotate.enabled,true)');
			//},500);
			//}
			
			/**
			Show the tour
			**/
			$('#tour').show();
			
			/**
			Set menu active item
			**/
			//$('.menu .dropdown a').removeClass('active');
			
			//if(_pano === null) {
			//	$('a[data-url="monster-registratie-9"]').addClass('active');
			//} else {
			//	$('a[data-url="' + _pano + '"').addClass('active');
			//
		
		},100);
		
	};
		
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
		
		this.toggleInfo = function() {

			if($('.js-info-status').val() == 0) {
			
				$('.js-info').stop().animate({
					'right':0
				},500,'easein');

				$('.js-info-status').val(1);

				$('.js-open').hide();
				$('.js-close').show();

			} else {

				$('.js-info').stop().animate({
					'right':-600
				},500,'easein');

				$('.js-info-status').val(0);

				$('.js-open').show();
				$('.js-close').hide();

			}

		};

		/*
		Update pano URL and go routing
		*/
		this.updateUrl = function(new_url) {

			/*
			Set: Begin scene
			*/
			if(url[1] === '') {
				
				window.location = globalUrl + '/facade/-126|0|0';
				
			} else {
				
				if(typeof new_url !== 'undefined' && new_url !== '') {
					var _urlParams = new URLSearchParams(window.location.search);
					window.history.pushState('obj','',globalUrl + '/' + new_url + '?' + _urlParams);
				}
			}
			
			/*
			Get new URL
			*/
			url = getUrl();

			/*
			Reset active
			*/
			$('.overlay').find('.link').removeClass('active');
			$('.overlay').find('.link2').removeClass('active');

			/*
			Reset extra button
			*/
			$('.js-change-lineup').stop().animate({
				'left':-120
			},500);

			$('.js-view-ceiling').stop().animate({
				'left':-120
			},500);

			/*
			Close info box
			*/
			if($('.js-info-status').val() == 1) {
				specific_360.toggleInfo();
			}

			/*
			Set: Scene
			*/
			switch(url[1]) {

				default:
				case 'facade':
					_call_scene = 'Exterior';

					/*
					Get: Position
					*/
					if(url[2] == '') {
						_coordinates_array 		= '-126|0|0';
					} else {
						_coordinates_array 		= url[2];
					}
					_coordinates_array 		= _coordinates_array.split('|');

					$('.js-now').html('Facade');

					$('.js-icon-facade').closest('.link').addClass('active');
					$('.js-icon-facade').addClass('visited');

					specific_360.getInfo('facade');
				break;

				/*
				HALLWAY ***********************************
				HALLWAY ***********************************
				HALLWAY ***********************************
				HALLWAY ***********************************
				*/
				case 'hallway':
					_call_scene = 'hallway-rooms';

					/*
					Get: Position
					*/
					if(url[2] == '') {
						_coordinates_array 		= '-318|0|1';
					} else {
						_coordinates_array 		= url[2];
					}
					_coordinates_array 		= _coordinates_array.split('|');

					$('.js-now').html('Hallway');

					$('.js-icon-facade').closest('.link').addClass('active');
					$('.js-icon-facade').addClass('visited');

					specific_360.getInfo('hallway');
				break;

				/*
				PASSAGE ***********************************
				PASSAGE ***********************************
				PASSAGE ***********************************
				PASSAGE ***********************************
				*/
				case 'passage':
					_call_scene = 'passage';

					/*
					Get: Position
					*/
					if(url[2] == '') {
						_coordinates_array 		= '-290|0|6';
					} else {
						_coordinates_array 		= url[2];
					}
					_coordinates_array 		= _coordinates_array.split('|');

					$('.js-now').html('Passage');

					$('.js-icon-facade').closest('.link').addClass('active');
					$('.js-icon-facade').addClass('visited');

					specific_360.getInfo('passage');
				break;

				/*
				LOBBY ***********************************
				LOBBY ***********************************
				LOBBY ***********************************
				LOBBY ***********************************
				*/
				case 'lobby':

					switch(url[2]) {

						default:
						case '1':

							_call_scene = 'lobby-1';

							/*
							Get: Position
							*/
							if(url[3] == '') {
								_coordinates_array 		= '80|0|1';
							} else {
								_coordinates_array 		= url[3];
							}
							_coordinates_array 		= _coordinates_array.split('|');

							specific_360.getInfo('lobby-frontside');

						break;

						case '2':

							_call_scene = 'lobby-2';

							/*
							Get: Position
							*/
							if(url[3] == '') {
								_coordinates_array 		= '155|0|4';
							} else {
								_coordinates_array 		= url[3];
							}
							_coordinates_array 		= _coordinates_array.split('|');

							specific_360.getInfo('lobby-backside');

						break;

						case '3':

							_call_scene = 'lobby-3';

							/*
							Get: Position
							*/
							if(url[3] == '') {
								_coordinates_array 		= '-159|0|5';
							} else {
								_coordinates_array 		= url[3];
							}
							_coordinates_array 		= _coordinates_array.split('|');

							specific_360.getInfo('lobby-backside');

						break;

					}

					$('.js-now').html('Lobby');

					$('.js-icon-lobby').closest('.link').addClass('active');
					$('.js-icon-lobby').addClass('visited');

				break;

				/*
				BEDROOMS ***********************************
				BEDROOMS ***********************************
				BEDROOMS ***********************************
				BEDROOMS ***********************************
				*/
				case 'bedrooms':

					switch(url[2]) {

						default:
						case 'superior-room':

							$('.js-now').html('Superior room');

							$('.js-icon-bedrooms').closest('.link').addClass('active');
							$('.js-bedroom-1').addClass('active');
							$('.js-icon-bedroom-1').addClass('visited');

							/*
							Set: Seen
							*/
							_bedroom_array = $('.js-seen-bedrooms').val();
							_bedroom_array = _bedroom_array.split(',');
							_bedroom_array[0] = 1;
							_bedroom_str = _bedroom_array.join();
							$('.js-seen-bedrooms').val(_bedroom_str);

							switch(url[3]) {

								default:
								case '1':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-354|0|10';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'Superior-1';

									specific_360.getInfo('bedroom-superiour');

								break;

								case '2':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-123|0|7';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'Superior-2';

									specific_360.getInfo('bedroom-superiour');

								break;

								case '3':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-123|0|7';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'Superior-3';

									specific_360.getInfo('bedroom-superiour');

								break;

							}

						break;

						case 'premium-room':

							$('.js-now').html('Premium room');

							$('.js-icon-bedrooms').closest('.link').addClass('active');
							$('.js-bedroom-2').addClass('active');
							$('.js-icon-bedroom-2').addClass('visited');

							/*
							Set: Seen
							*/
							_bedroom_array 		= $('.js-seen-bedrooms').val();
							_bedroom_array 		= _bedroom_array.split(',');
							_bedroom_array[1] 	= 1;
							_bedroom_str 		= _bedroom_array.join();
							$('.js-seen-bedrooms').val(_bedroom_str);

							switch(url[3]) {

								default:
								case '1':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-128|0|7';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'Premium-1';									

									specific_360.getInfo('bedroom-premium');

								break;

								case '2':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-128|0|7';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'Premium-2';									

									specific_360.getInfo('bedroom-premium');

								break;

							}

						break;

						case 'junior-suite':

							$('.js-now').html('Junior suite');

							$('.js-icon-bedrooms').closest('.link').addClass('active');
							$('.js-bedroom-3').addClass('active');
							$('.js-icon-bedroom-3').addClass('visited');

							/*
							Set: Seen
							*/
							_bedroom_array 		= $('.js-seen-bedrooms').val();
							_bedroom_array 		= _bedroom_array.split(',');
							_bedroom_array[2] 	= 1;
							_bedroom_str 		= _bedroom_array.join();
							$('.js-seen-bedrooms').val(_bedroom_str);

							switch(url[3]) {

								default:
								case '1':
									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-108|0|18';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'JuniorSuite-1';

									specific_360.getInfo('bedroom-junior');
								break;

								case '2':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-323|0|32';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'JuniorSuite-2';

									specific_360.getInfo('bedroom-junior');

								break;
								case '3':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-470|0|16';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'JuniorSuite-3';

									specific_360.getInfo('bedroom-junior');

								break;
								case '4':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-323|0|32';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'JuniorSuite-4';

									specific_360.getInfo('bedroom-junior');

								break;


							}

						break;

						case 'amsterdam-suite':

							$('.js-now').html('Amsterdam suite');

							$('.js-icon-bedrooms').closest('.link').addClass('active');
							$('.js-bedroom-4').addClass('active');
							$('.js-icon-bedroom-4').addClass('visited');

							/*
							Set: Seen
							*/
							_bedroom_array 		= $('.js-seen-bedrooms').val();
							_bedroom_array 		= _bedroom_array.split(',');
							_bedroom_array[3] 	= 1;
							_bedroom_str 		= _bedroom_array.join();
							$('.js-seen-bedrooms').val(_bedroom_str);

							switch(url[3]) {

								default:
								case '1':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-46|0|20';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'AmsterdamSuite-1';
							
									specific_360.getInfo('bedroom-amsterdam');

								break;

								case '2':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-140|0|12';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'AmsterdamSuite-2';
							
									specific_360.getInfo('bedroom-amsterdam');

								break;

								case '3':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-46|0|20';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'AmsterdamSuite-3';
							
									specific_360.getInfo('bedroom-amsterdam');

								break;

								case '4':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-46|0|20';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'AmsterdamSuite-4';
							
									specific_360.getInfo('bedroom-amsterdam');

								break;

								case '5':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-130|0|15';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'AmsterdamSuite-5';
							
									specific_360.getInfo('bedroom-amsterdam');

								break;

								case '6':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-6|0|0';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'AmsterdamSuite-6';
							
									specific_360.getInfo('bedroom-amsterdam');

								break;

							}

						break;

					}
					
				break;

				/*
				GYM / WELLNESS ***********************************
				GYM / WELLNESS ***********************************
				GYM / WELLNESS ***********************************
				GYM / WELLNESS ***********************************
				*/
				case 'gym-wellness':
					
					switch(url[2]) {

						default:
						case 'gym':

							$('.js-now').html('Gym');

							$('.js-icon-wellnesscenter').closest('.link').addClass('active');
							$('.js-wellnesscenter-1').addClass('active');
							$('.js-icon-wellnesscenter-1').addClass('visited');

							/*
							Set: Seen
							*/
							_wellnesscenter_array 		= $('.js-seen-wellnesscenter').val();
							_wellnesscenter_array 		= _wellnesscenter_array.split(',');
							_wellnesscenter_array[0] 	= 1;
							_wellnesscenter_str 		= _wellnesscenter_array.join();
							$('.js-seen-wellnesscenter').val(_wellnesscenter_str);

							switch(url[3]) {

								default:
								case '1':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-48|0|-1';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'Gym-1';

									specific_360.getInfo('gym');

								break;

								case '2':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-354|0|8';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'Gym-2';

									specific_360.getInfo('gym');

								break;

								case '3':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-42|0|5';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'Gym-3';

									specific_360.getInfo('gym');

								break;

							}

						break;

						case 'wellness':

							$('.js-now').html('Wellness');

							$('.js-icon-wellnesscenter').closest('.link').addClass('active');
							$('.js-wellnesscenter-2').addClass('active');
							$('.js-icon-wellnesscenter-2').addClass('visited');

							/*
							Set: Seen
							*/
							_wellnesscenter_array 		= $('.js-seen-wellnesscenter').val();
							_wellnesscenter_array 		= _wellnesscenter_array.split(',');
							_wellnesscenter_array[1] 	= 1;
							_wellnesscenter_str 		= _wellnesscenter_array.join();
							$('.js-seen-wellnesscenter').val(_wellnesscenter_str);

							// switch(url[3]) {

							// 	case '1':
							// 	case '2':

								/*
								Get: Position
								*/
								if(url[3] == '') {
									_coordinates_array 		= '-44|0|9';
								} else {
									_coordinates_array 		= url[3];
								}
								_coordinates_array 		= _coordinates_array.split('|');

								_call_scene = 'Wellness';

								specific_360.getInfo('wellness');

							// 	break;

							// }

						break;

					}

				break;

				/*
				RESTAURANTS ***********************************
				RESTAURANTS ***********************************
				RESTAURANTS ***********************************
				RESTAURANTS ***********************************
				*/
				case 'restaurants':
					
					switch(url[2]) {

						default:
						case 'restaurant-appel':

							$('.js-now').html('Restaurant Appel');

							$('.js-icon-restaurants').closest('.link').addClass('active');
							$('.js-restaurant-1').addClass('active');
							$('.js-icon-restaurant-1').addClass('visited');

							/*
							Set: Seen
							*/
							_restaurants_array 		= $('.js-seen-restaurants').val();
							_restaurants_array 		= _restaurants_array.split(',');
							_restaurants_array[0] 	= 1;
							_restaurants_str 		= _restaurants_array.join();
							$('.js-seen-restaurants').val(_restaurants_str);

							switch(url[3]) {

								case '1':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-309|0|15';
									} else {
										_coordinates_array 		= url[4];
									}

									_coordinates_array 			= _coordinates_array.split('|');

									_call_scene = 'RestaurantAppel-1';

									specific_360.getInfo('restaurants-appel');

								break;
								case '2':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-309|0|15';
									} else {
										_coordinates_array 		= url[4];
									}

									_coordinates_array 			= _coordinates_array.split('|');

									_call_scene = 'RestaurantAppel-2';

									specific_360.getInfo('restaurants-appel');


								break;
								case '3':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-309|0|15';
									} else {
										_coordinates_array 		= url[4];
									}

									_coordinates_array 			= _coordinates_array.split('|');

									_call_scene = 'RestaurantAppel-3';

									specific_360.getInfo('restaurants-appel');


								break;
								case '4':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-309|0|15';
									} else {
										_coordinates_array 		= url[4];
									}

									_coordinates_array 			= _coordinates_array.split('|');

									_call_scene = 'RestaurantAppel-4';

									specific_360.getInfo('restaurants-appel');

								break;
								case '5':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-309|0|15';
									} else {
										_coordinates_array 		= url[4];
									}

									_coordinates_array 			= _coordinates_array.split('|');

									_call_scene = 'RestaurantAppel-5';

									specific_360.getInfo('restaurants-appel');

								break;
								default:
								case '6':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-309|0|15';
									} else {
										_coordinates_array 		= url[4];
									}

									_coordinates_array 			= _coordinates_array.split('|');

									_call_scene = 'RestaurantAppel-6';

									specific_360.getInfo('restaurants-appel');

								break;
								case '7':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-309|0|15';
									} else {
										_coordinates_array 		= url[4];
									}

									_coordinates_array 			= _coordinates_array.split('|');

									_call_scene = 'RestaurantAppel-7';

									specific_360.getInfo('restaurants-appel');

								break;
								case '8':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-309|0|15';
									} else {
										_coordinates_array 		= url[4];
									}

									_coordinates_array 			= _coordinates_array.split('|');

									_call_scene = 'RestaurantAppel-8';

									specific_360.getInfo('restaurants-appel');

								break;

							}

						break;

						case 'bottles-jars':

							$('.js-now').html('Bottles & Jars');

							$('.js-icon-restaurants').closest('.link').addClass('active');
							$('.js-restaurant-2').addClass('active');
							$('.js-icon-restaurant-2').addClass('visited');

							/*
							Set: Seen
							*/
							_restaurants_array 		= $('.js-seen-restaurants').val();
							_restaurants_array 		= _restaurants_array.split(',');
							_restaurants_array[1] 	= 1;
							_restaurants_str 		= _restaurants_array.join();
							$('.js-seen-restaurants').val(_restaurants_str);

							switch(url[3]) {

								default:
								case '1':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-154|0|4';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'Bottles_Jars-1';

									specific_360.getInfo('bottles-jars');

								break;

								case '2':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-154|0|4';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'Bottles_Jars-2';

									specific_360.getInfo('bottles-jars');


								break;

								case '3':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-154|0|4';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'Bottles_Jars-3';

									specific_360.getInfo('bottles-jars');

								break;

							}

						break;

						case 'restaurant-vermeer':

							$('.js-now').html('Restaurant Vermeer');

							$('.js-icon-restaurants').closest('.link').addClass('active');
							$('.js-restaurant-3').addClass('active');
							$('.js-icon-restaurant-3').addClass('visited');

							/*
							Set: Seen
							*/
							_restaurants_array 		= $('.js-seen-restaurants').val();
							_restaurants_array 		= _restaurants_array.split(',');
							_restaurants_array[2] 	= 1;
							_restaurants_str 		= _restaurants_array.join();
							$('.js-seen-restaurants').val(_restaurants_str);

							switch(url[3]) {

								default:
								case '1':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-428|0|6';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'Vermeer-1';

									specific_360.getInfo('restaurant-vermeer');

								break;

								case '2':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-98|0|4';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'Vermeer-2';

									specific_360.getInfo('restaurant-vermeer');

								break;

								case '3':

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-528|0|4';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 		= _coordinates_array.split('|');

									_call_scene = 'Vermeer-3';

									specific_360.getInfo('restaurant-vermeer');

								break;

							}

						break;

					}

				break;

				/*
				MEETING ROOMS ***********************************
				MEETING ROOMS ***********************************
				MEETING ROOMS ***********************************
				MEETING ROOMS ***********************************
				*/
				case 'meeting-rooms':
					
					switch(url[2]) {

						default:
						case 'ferdinand-bol':

							/*
							Show extra button
							*/
							$('.js-change-lineup').stop().animate({
								'left':0
							},500);

							$('.js-now').html('Ferdinand Bol');

							$('.js-icon-meetingrooms').closest('.link').addClass('active');
							$('.js-meetingrooms-1').addClass('active');
							$('.js-icon-meetingrooms-1').addClass('visited');

							/*
							Set: Seen
							*/
							_meetingrooms_array 	= $('.js-seen-meetingrooms').val();
							_meetingrooms_array 	= _meetingrooms_array.split(',');
							_meetingrooms_array[0] 	= 1;
							_meetingrooms_str 		= _meetingrooms_array.join();
							$('.js-seen-meetingrooms').val(_meetingrooms_str);

							switch(url[3]) {

								default:
								case '1':

									$('.js-change-lineup').find('span').html('Change to lineup 2');
									$('.js-change-lineup').data('url','meeting-rooms/ferdinand-bol/2/-871|0|3');

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-487|0|6';
									} else {
										_coordinates_array 		= url[4];
									}

									_coordinates_array 			= _coordinates_array.split('|');

									_call_scene = 'FerdinandBol-Zaal1-2';

									specific_360.getInfo('meetingrooms-ferdinandbol');

								break;

								case '2':

									$('.js-change-lineup').find('span').html('Change to lineup 1');
									$('.js-change-lineup').data('url','meeting-rooms/ferdinand-bol/1/-487|0|6');

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-871|0|3';
									} else {
										_coordinates_array 		= url[4];
									}

									_coordinates_array 			= _coordinates_array.split('|');

									_call_scene = 'FerdinandBol-Zaal1-4';

									specific_360.getInfo('meetingrooms-ferdinandbol');

								break;

							}

						break;

						case 'albert-cuyp':

							$('.js-now').html('Albert Cuyp');

							$('.js-icon-meetingrooms').closest('.link').addClass('active');
							$('.js-meetingrooms-2').addClass('active');
							$('.js-icon-meetingrooms-2').addClass('visited');

							/*
							Show extra button
							*/
							$('.js-view-ceiling').stop().animate({
								'left':0
							},500);

							/*
							Set: Seen
							*/
							_meetingrooms_array 	= $('.js-seen-meetingrooms').val();
							_meetingrooms_array 	= _meetingrooms_array.split(',');
							_meetingrooms_array[1] 	= 1;
							_meetingrooms_str 		= _meetingrooms_array.join();
							$('.js-seen-meetingrooms').val(_meetingrooms_str);

							// switch(url[3]) {

							// 	default:
							// 	case '1':
							// 	case '2':
							// 	case '3':

									/*
									Get: Position
									*/
									if(url[3] == '') {
										_coordinates_array 		= '-493|0|7';
									} else {
										_coordinates_array 		= url[3];
									}
									_coordinates_array 			= _coordinates_array.split('|');

									_call_scene = 'AlbertCuyp-1';

									specific_360.getInfo('meetingrooms-albertcuyp');

							// 	break;

							// }

						break;

						case 'jan-van-goyen':

							/*
							Show extra button
							*/
							$('.js-change-lineup').stop().animate({
								'left':0
							},500);

							$('.js-now').html('Jan van Goyen');

							$('.js-icon-meetingrooms').closest('.link').addClass('active');
							$('.js-meetingrooms-3').addClass('active');
							$('.js-icon-meetingrooms-3').addClass('visited');

							/*
							Set: Seen
							*/
							_meetingrooms_array 	= $('.js-seen-meetingrooms').val();
							_meetingrooms_array 	= _meetingrooms_array.split(',');
							_meetingrooms_array[2] 	= 1;
							_meetingrooms_str 		= _meetingrooms_array.join();
							$('.js-seen-meetingrooms').val(_meetingrooms_str);

							switch(url[3]) {

								default:
								case 'meeting':

									$('.js-change-lineup').find('span').html('Change to dinner');
									$('.js-change-lineup').data('url','meeting-rooms/jan-van-goyen/dinner/1/-71|0|11');

									$('.js-icon-meetingrooms-3-1').closest('.link').addClass('active');
									$('.js-meetingrooms-3-1').addClass('active');
									$('.js-icon-meetingrooms-3-1').addClass('visited');

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-147|0|5';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 			= _coordinates_array.split('|');

									_call_scene = 'JanVanGoyen-Meeting';

									specific_360.getInfo('meetingrooms-janvangoyen-meeting');

								break;

								case 'dinner':

									$('.js-change-lineup').find('span').html('Change to meeting');
									$('.js-change-lineup').data('url','meeting-rooms/jan-van-goyen/meeting/-147|0|5');

									$('.js-icon-meetingrooms-3-2').closest('.link').addClass('active');
									$('.js-meetingrooms-3-2').addClass('active');
									$('.js-icon-meetingrooms-3-2').addClass('visited');

									switch(url[4]) {

										case '1':
											
											/*
											Get: Position
											*/
											if(url[5] == '') {
												_coordinates_array 		= '-67|0|4';
											} else {
												_coordinates_array 		= url[5];
											}
											_coordinates_array 			= _coordinates_array.split('|');

											_call_scene = 'JanVanGoyen-Diner-1';

											specific_360.getInfo('meetingrooms-janvangoyen-dinner');

										break;

										case '2':

											/*
											Get: Position
											*/
											if(url[5] == '') {
												_coordinates_array 		= '-67|0|4';
											} else {
												_coordinates_array 		= url[5];
											}
											_coordinates_array 			= _coordinates_array.split('|');

											_call_scene = 'JanVanGoyen-Diner-2';

											specific_360.getInfo('meetingrooms-janvangoyen-dinner');

										break;

									}

								break;
							}

						break;

						case 'frans-hals':

							$('.js-now').html('Frans Hals');

							$('.js-icon-meetingrooms').closest('.link').addClass('active');
							$('.js-meetingrooms-4').addClass('active');
							$('.js-icon-meetingrooms-4').addClass('visited');/*

							/*
							Set: Seen
							*/
							_meetingrooms_array 	= $('.js-seen-meetingrooms').val();
							_meetingrooms_array 	= _meetingrooms_array.split(',');
							_meetingrooms_array[3] 	= 1;
							_meetingrooms_str 		= _meetingrooms_array.join();
							$('.js-seen-meetingrooms').val(_meetingrooms_str);

							// switch(url[3]) {

							// 	default:
							// 	case '1':
							// 	case '2':
							// 	case '3':

									/*
									Get: Position
									*/
									if(url[3] == '') {
										_coordinates_array 		= '-136|0|5';
									} else {
										_coordinates_array 		= url[3];
									}
									_coordinates_array 			= _coordinates_array.split('|');

									_call_scene = 'FransHals-1';

									specific_360.getInfo('meetingrooms-franshals');

							// 	break;

							// }

						break;

						case 'olofs':

							/*
							Show extra button
							*/
							if(url[3] != 'foyer') {
								$('.js-change-lineup').stop().animate({
									'left':0
								},500);
							}

							$('.js-now').html('Olof\'s');

							$('.js-icon-meetingrooms').closest('.link').addClass('active');
							$('.js-meetingrooms-5').addClass('active');
							$('.js-icon-meetingrooms-5').addClass('visited');

							/*
							Set: Seen
							*/
							_meetingrooms_array 	= $('.js-seen-meetingrooms').val();
							_meetingrooms_array 	= _meetingrooms_array.split(',');
							_meetingrooms_array[4] 	= 1;
							_meetingrooms_str 		= _meetingrooms_array.join();
							$('.js-seen-meetingrooms').val(_meetingrooms_str);

							switch(url[3]) {

								default:
								case 'foyer':

									$('.js-icon-meetingrooms-3-1').closest('.link').addClass('active');
									$('.js-meetingrooms-3-1').addClass('active');
									$('.js-icon-meetingrooms-3-1').addClass('visited');

									/*
									Get: Position
									*/
									if(url[4] == '') {
										_coordinates_array 		= '-130|0|1';
									} else {
										_coordinates_array 		= url[4];
									}
									_coordinates_array 			= _coordinates_array.split('|');

									_call_scene = 'Olofs_Foyer';

									specific_360.getInfo('meetingrooms-olofs-foyer');

								break;

								case 'meeting':

									$('.js-icon-meetingrooms-5-1').closest('.link').addClass('active');
									$('.js-meetingrooms-5-1').addClass('active');
									$('.js-icon-meetingrooms-5-1').addClass('visited');

									switch(url[4]) {

										case '1':

											$('.js-change-lineup').find('span').html('Change to dinner');
											$('.js-change-lineup').data('url','meeting-rooms/olofs/dinner/1/-491|0|-8');

											/*
											Get: Position
											*/
											if(url[5] == '') {
												_coordinates_array 		= '-128|0|-8';
											} else {
												_coordinates_array 		= url[5];
											}
											_coordinates_array 			= _coordinates_array.split('|');

											_call_scene = 'Olofs-Meeting-1';

											specific_360.getInfo('meetingrooms-olofs-meeting');

										break;

										case '2':

											$('.js-change-lineup').find('span').html('Change to dinner');
											$('.js-change-lineup').data('url','meeting-rooms/olofs/dinner/1/-491|0|-8');

											/*
											Get: Position
											*/
											if(url[5] == '') {
												_coordinates_array 		= '-128|0|-8';
											} else {
												_coordinates_array 		= url[5];
											}
											_coordinates_array 			= _coordinates_array.split('|');

											_call_scene = 'Olofs-Meeting-2';

											specific_360.getInfo('meetingrooms-olofs-meeting');

										break;

									}

								break;

								case 'dinner':

									$('.js-icon-meetingrooms-5-2').closest('.link').addClass('active');
									$('.js-meetingrooms-5-2').addClass('active');
									$('.js-icon-meetingrooms-5-2').addClass('visited');

									switch(url[4]) {

										case '1':

											$('.js-change-lineup').find('span').html('Change to meeting');
											$('.js-change-lineup').data('url','meeting-rooms/olofs/meeting/1/-491|0|-8');

											/*
											Get: Position
											*/
											if(url[5] == '') {
												_coordinates_array 		= '-492|0|-17';
											} else {
												_coordinates_array 		= url[5];
											}
											_coordinates_array 			= _coordinates_array.split('|');

											_call_scene = 'Olofs-Dinner-1';

											specific_360.getInfo('meetingrooms-olofs-dinner');

										break;


										case '2':

											$('.js-change-lineup').find('span').html('Change to meeting');
											$('.js-change-lineup').data('url','meeting-rooms/olofs/meeting/1/-491|0|-8');

											/*
											Get: Position
											*/
											if(url[5] == '') {
												_coordinates_array 		= '-481|0|-1';
											} else {
												_coordinates_array 		= url[5];
											}
											_coordinates_array 			= _coordinates_array.split('|');

											_call_scene = 'Olofs-Dinner-2';

											specific_360.getInfo('meetingrooms-olofs-dinner');

										break;

										case '3':

											$('.js-change-lineup').find('span').html('Change to meeting');
											$('.js-change-lineup').data('url','meeting-rooms/olofs/meeting/1/-491|0|-8');

											/*
											Get: Position
											*/
											if(url[5] == '') {
												_coordinates_array 		= '-475|0|4';
											} else {
												_coordinates_array 		= url[5];
											}
											_coordinates_array 			= _coordinates_array.split('|');

											_call_scene = 'Olofs-Dinner-3';

											specific_360.getInfo('meetingrooms-olofs-dinner');

										break;

										case '4':

											$('.js-change-lineup').find('span').html('Change to meeting');
											$('.js-change-lineup').data('url','meeting-rooms/olofs/meeting/1/-491|0|-8');

											/*
											Get: Position
											*/
											if(url[5] == '') {
												_coordinates_array 		= '-75|0|0';
											} else {
												_coordinates_array 		= url[5];
											}
											_coordinates_array 			= _coordinates_array.split('|');

											_call_scene = 'Olofs-Dinner-Mezzanine-1';

											specific_360.getInfo('meetingrooms-olofs-mezzanine');

										break;

										case '5':

											$('.js-change-lineup').find('span').html('Change to meeting');
											$('.js-change-lineup').data('url','meeting-rooms/olofs/meeting/1/-491|0|-8');

											/*
											Get: Position
											*/
											if(url[5] == '') {
												_coordinates_array 		= '-508|0|10';
											} else {
												_coordinates_array 		= url[5];
											}
											_coordinates_array 			= _coordinates_array.split('|');

											_call_scene = 'Olofs-Dinner-Mezzanine-2';

											specific_360.getInfo('meetingrooms-olofs-mezzanine');

										break;

									}

								break;
							}

						break;

					}

				break;

			}

			/*
			Bedrooms: Check if all seen?
			*/
			if(
				$('.js-seen-bedrooms').val() == '1,1,1,1'
			) {
				$('.js-icon-bedrooms').addClass('visited');
			}
			/*
			Wellness: Check if all seen?
			*/
			if(
				$('.js-seen-wellnesscenter').val() == '1,1'
			) {
				$('.js-icon-wellnesscenter').addClass('visited');
			}
			/*
			Restaurants: Check if all seen?
			*/
			if(
				$('.js-seen-restaurants').val() == '1,1,1'
			) {
				$('.js-icon-restaurants').addClass('visited');
			}
			/*
			Meeting Rooms: Check if all seen?
			*/
			if(
				$('.js-seen-meetingrooms').val() == '1,1,1,1,1'
			) {
				$('.js-icon-meetingrooms').addClass('visited');
			}

			/*
			Load: Scene
			*/
			krpano.call("loadscene('scene_" + _call_scene + "',null,MERGE,BLEND(0.4)); lookat(" + _coordinates_array[0] + ',' + _coordinates_array[2] + "," + _coordinates_array[3] + ");");

		};

		/*
		Get: Info
		*/
		this.getInfo = function(_scene) {

			$.ajax({
				url: globalUrl + '/a/l/scene-info',
				method:'POST',
				data:{
					scene:_scene
				},
				headers: { 
					'go-load':1 
				}
			})
			.done(function(data) {

				/*
				Zet in infobox
				*/
				$('.js-info-inside').html(data);

			})
			.always(function() {
			});

		};

		/*
		Coordinates
		*/
		this.trackCoordinates = function() {
					
			/**
			Clear: Timeout
			**/
			clearTimeout(timeout);
		
			/**
			Track Coordinates
			**/
			var timeout = setInterval(function() {
				
				_hlookat = krpano.get('view.hlookat').toString().substring(0,4);
				_vlookat = krpano.get('view.vlookat').toString().substring(0,4);
				
				// var _url = new URL(document.URL);
				// var _pano = _url.searchParams.get("p");
				// var _look = _url.searchParams.get("l");
				// _look = _look.replace(/|/g,',');
				
				console.log(Math.round(_hlookat) + '|0|' + Math.round(_vlookat));
				
				// window.history.pushState('obj','','./?p=' + _pano + '&l=' + Math.round(_hlookat) + '|0|' + Math.round(_vlookat));
				
			},1000);
			
			
		};
		
		/*
		Tooltip
		*/
		this.tooltip = function(i,href) {
			
			if(i==='on') {
				
				if(isTooltip === 0 && isPopupOpen === 0 && screenWidth > 600) {
					
					_get = href.split('/');
					
					/**
					Get tooltip text from localStorage (JSON)
					**/
					var storage 		= localStorage.getItem('tooltips');
					var get_tooltips 	= JSON.parse(storage);
					var tooltip 		= get_tooltips[_get[0]][_get[1]];
					
					$('.tooltip .js-tooltip').html(tooltip);
				
					/**
					Show Tooltip
					**/
					$('.tooltip').show();
					
					isTooltip = 1;
					
				}
				
				/**
				Update Tooltip on Mousemove
				**/
				_width = $('.tooltip .js-tooltip').outerWidth();
						
				$('.tooltip').css({
				   left:  mouse_posX - ((_width/2)-5),
				   top:   mouse_posY - 100
				});
				
			} else {
				
				if(isTooltip === 1) {
				
					$('.tooltip').hide();
					isTooltip = 0;
				
				}
			}
			
		};
		
		/*
		Open: Popup / Hotspot
		*/
		this.openPopup = function(id) {
			
			/**
			Hide tooltip on open popup
			**/
			$('.tooltip').hide();
			isTooltip = 0;
			
			router.beforeRoute(globalUrl + '/' + id,1);
			popup.open(0,'popspot/' + id);
			
		};
	
		/*
		Toggle: Helpscreen
		*/
		this.toggleHelpscreen = function() {
			
			popup.open(0,'helpscreen');
			
		};
		
		/*
		Toggle: Map
		*/
		this.toggleMap = function() {
			
			_url = 'map/' + url[1];
			if(urlParts[1] !== '') {
				_url = _url + '/' + url[2] + '/' + urlParts[3];
			}
			
			popup.open(0,_url);
			
		};
		
		/*
		Toggle: VR
		*/
		this.toggleVR = function() {
			
			/**
			Disable hover
			**/
			//$('.js-button-vr').unbind("mouseenter mouseleave");
			
			var krpano = document.getElementById('krpanoSWFObject');
		
			if(isVR === 0) {
				krpano.call("webvr.enterVR()");
				//$('.js-button').hide();
				// $('js-button-gyroscope').hide();
			} else {
				//$('.js-button').show();
				//$('js-button-gyroscope').show();
			}
			
		};
		
		/*
		Toggle: Gyroscope
		*/
		this.toggleGyroscope = function() {
			
			/**
			Disable hover
			**/
			//$('.js-button-360').unbind("mouseenter mouseleave");
			
			var krpano = document.getElementById('krpanoSWFObject');
		
			if(isGyro === 0) {
				krpano.set("plugin[gyro].enabled", "true");
				$('.js-button-fullscreen').hide();
				$('.js-button-vr').hide();
				// $('.js-gyroscope-onoff').removeClass('icon-extra-off');
				// $('.js-gyroscope-onoff').addClass('icon-extra-on');
				isGyro = 1;
			} else {
				krpano.set("plugin[gyro].enabled", "false");
				$('.js-button-fullscreen').show();
				$('.js-button-vr').show();
				// $('.js-gyroscope-onoff').removeClass('icon-extra-on');
				// $('.js-gyroscope-onoff').addClass('icon-extra-off');
				isGyro = 0;
			}
			
		};
		
		/*
		Toggle: Fullscreen
		*/
		this.toggleFullscreen = function() {
			
			if(isFullscreen === 1) {
				
				/*
				Switch icon
				*/
				$('.js-button-fullscreen').removeClass('active');
				
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
				
				isFullscreen = 0;
				
			} else {
				
				var element = document.documentElement;
				
				  if(element.requestFullscreen) {
					element.requestFullscreen();
				  } else if(element.mozRequestFullScreen) {
					element.mozRequestFullScreen();
				  } else if(element.webkitRequestFullscreen) {
					element.webkitRequestFullscreen();
				  } else if(element.msRequestFullscreen) {
					element.msRequestFullscreen();
				  }
				  
				  
				/*
				Switch icon
				*/
				$('.js-button-fullscreen').addClass('active');
				  
				isFullscreen = 1;
			}
			
		};
			
	
}).apply(specific_360); 